
import {
  defineComponent,
  ref,
  reactive,
  toRefs,
  onMounted,
  nextTick
} from 'vue'
import { useRoute } from 'vue-router'
import { useStore, mapState, mapMutations, mapActions } from 'vuex'
import globalsets from '@/utils/globalsets'
import Modal from '@/views/f10/modal.vue'
import { DownOutlined, UpOutlined } from '@ant-design/icons-vue'
import zsgk from './components/zsgk.vue'
import gzxx from './components/gzxx.vue'
import hyqz from './components/hyqz.vue'
import sdqzg from './components/sdqzg.vue'
import ws from '../../websocket/index'
export default defineComponent({
  components: {
    Modal, // 模态框
    DownOutlined,
    UpOutlined,
    zsgk,
    gzxx,
    hyqz,
    sdqzg
  },
  props: {
    theme: {
      type: String,
      default: function () {
        return ''
      }
    }
  },
  setup(props, context) {
    const pageData: any = reactive({
      currentshares: {
        LastPrice: 0,
        RiseandFall: 0,
        PreClosePrice: 0,
        increase: 0,
        InstrumentID: '',
        name: '',
        key: new Date().getTime() + '',
        InstStatus: ''
      },
      nav: [
        { key: 'zsgk', title: '指数概况' },
        { key: 'gzxx', title: '估值信息' },
        { key: 'hyqz', title: '行业权重' },
        { key: 'sdqzg', title: '十大权重股' }
      ],
      containerRef: () => document.querySelector('.wrapper'),
      isOpen: true,
      target: () => document.querySelector('.wrapper'),
      activeIndex: '',
      wrapNav: [
        { key: 'zsgk', title: '指数概况' },
        { key: 'gzxx', title: '估值信息' },
        { key: 'hyqz', title: '行业权重', time: '2022-09-15' },
        { key: 'sdqzg', title: '十大权重股', time: '2022-09-15' }
      ],
      showbacktop: true,
      websock: null,
      token: ''
    })
    const route = useRoute()

    // 描点点击
    function changehash(e: any) {
      pageData.activeIndex = e.split('#')[1]
    }
    function selecthash(e: any, link: any) {
      e.preventDefault()
    }

    // 回到顶部
    let scrollTop = 0
    const scrollEndTop = 0
    let timer: any = null
    const hashwrapper: any = {}
    function scrollhashwrapper() {
      pageData.showbacktop = true
      clearTimeout(timer)
      timer = setTimeout(showtop, 3000)
      scrollTop = hashwrapper.scrollTop
    }
    function showtop() {
      pageData.showbacktop = false
    }

    // 获取token
    async function gettoken() {
      pageData.token = await globalsets.getToken()
    }

    // ws.websocket.safeSubscribeDYNA(route.query.code, route.query.market,)
    ws.websocket.on('onMessage', msg => {
      const _data = msg.QuoteData
      if (
        _data &&
        _data.StatisticsData &&
        (_data.StatisticsData || []).length > 0
      ) {
        pageData.currentshares.PreClosePrice =
          _data.StatisticsData[0].PreClosePrice
        pageData.currentshares.InstrumentID =
          _data.StatisticsData[0].InstrumentID
      }
      if (_data && _data.DynaData && (_data.DynaData || []).length > 0) {
        pageData.currentshares.LastPrice = _data.DynaData[0].LastPrice || null
      }
      if (_data && _data.StaticData && (_data.StaticData || []).length > 0) {
        pageData.currentshares.name = _data.StaticData[0].InstrumentName
        context.emit('currentshares', pageData.currentshares)
      }
      if (_data && (_data.InstStatusData || [])[0]) {
        pageData.currentshares.InstStatus = (
          (msg.QuoteData.InstStatusData || [])[0] || {}
        ).StatusType
      }
      if (_data && _data.StaticData && (_data.StaticData || []).length > 0) {
        pageData.currentshares.name = _data.StaticData[0].InstrumentName
        context.emit('currentshares', pageData.currentshares)
      }
      // 停牌
      if (pageData.currentshares.InstStatus === 6) {
        pageData.currentshares.RiseandFall = null
        pageData.currentshares.increase = null
        pageData.currentshares.LastPrice = null
      } else {
        pageData.currentshares.RiseandFall =
          pageData.currentshares.LastPrice -
          pageData.currentshares.PreClosePrice
        pageData.currentshares.increase =
          ((pageData.currentshares.LastPrice -
            pageData.currentshares.PreClosePrice) /
            pageData.currentshares.PreClosePrice) *
          100
      }
    })

    function chageTime({ index, time }) {
      pageData.wrapNav[index].time = window.moment(time * 1000).format('YYYY-MM-DD')
    }

    gettoken()
    return {
      ...toRefs(pageData),
      changehash,
      selecthash,
      getNumber: globalsets.getNumber,
      getNumber2: globalsets.getNumber2,
      getPencent: globalsets.getPencent,
      scrollhashwrapper,
      chageTime
    }
  }
})
